import { useContext, useEffect, useId } from "react"

import { InputContext } from "../Input"

export function useInputDescriptionElement(id?: string) {
  const internalID = useId()

  const descriptionID = id || internalID

  const context = useContext(InputContext)

  const { registerDescription, unregisterDescription } = context

  useEffect(() => {
    registerDescription?.(descriptionID)
    return () => unregisterDescription?.(descriptionID)
  }, [descriptionID, registerDescription, unregisterDescription])

  return { id: descriptionID }
}
